import gql from 'graphql-tag'
import {userFragment} from '../fragments'
import {managerFragment, registrationFragment} from "@/graphql/fragments";

export const CreateStudent = gql`
mutation CreateStudent($grade: Int, $classroomId: ID, $managerId: ID, $userId: ID) {
  createStudent(grade: $grade, classroomId: $classroomId, managerId: $managerId, userId: $userId) {
    student {
      id
      grade
      rawPassword
      classroom {
        id
        name
      }
      user {
        ...userFragment
      }
      manager {
        ...managerFragment
      }
      studentRegistration {
        ...registrationFragment
      }
    }
  }
}
${userFragment}
${managerFragment}
${registrationFragment}
`




export const UpdateStudent = gql`
mutation UpdateStudent($id: ID!,$grade: Int, $classroomId: ID) {
  updateStudent(id: $id,grade: $grade, classroomId: $classroomId) {
    student {
      id
      grade
      rawPassword
      classroom {
        id
        name
      }
      user {
        ...userFragment
      }
    }
  }
}
${userFragment}
`


export const DeleteStudent = gql`
mutation DeleteStudent($id: ID!) {
  deleteStudent(id: $id) {
    id_
  }
}
`

